import { SVGProps } from "react";

export function CheckTodoIllustration(props: SVGProps<SVGSVGElement>) {
  return (
    <svg width={88} height={88} viewBox="0 0 88 88" fill="none" {...props}>
      <mask
        id="check-todo-mask"
        width={72}
        height={72}
        x={8}
        y={8}
        maskUnits="userSpaceOnUse"
      >
        <circle cx={44} cy={44} r={36} fill="#F9F8F8" />
      </mask>
      <g mask="url(#check-todo-mask)">
        <circle cx={44} cy={44} r={36} fill="#DEDFE0" opacity={0.2} />
        <rect width={60} height={18} x={14} y={62} fill="#92C9B5" rx={2} />
        <path
          fill="#1F9E80"
          d="M20.5 74.749a.403.403 0 0 1-.297-.12.403.403 0 0 1-.12-.297v-6.25c0-.118.04-.217.12-.297.08-.08.18-.12.297-.12h2.99a.4.4 0 0 1 .26.094.412.412 0 0 1 .146.24l.104.5h1.917c.118 0 .217.04.297.12.08.08.12.178.12.296v3.334c0 .118-.04.217-.12.297a.402.402 0 0 1-.297.12h-2.156a.4.4 0 0 1-.26-.094.412.412 0 0 1-.146-.24l-.105-.5h-2.333v2.5c0 .118-.04.217-.12.297-.08.08-.179.12-.297.12Z"
        />
        <rect
          width={22}
          height={3}
          x={30}
          y={67}
          fill="#F7F8F8"
          opacity={0.9}
          rx={1.5}
        />
        <rect
          width={40}
          height={3}
          x={30}
          y={72}
          fill="#F7F8F8"
          opacity={0.6}
          rx={1.5}
        />
      </g>
      <rect width={68} height={20} x={10} y={16} fill="#1F9E80" rx={2} />
      <path
        fill="#F7F8F8"
        d="M17 30.5a.484.484 0 0 1-.356-.145A.483.483 0 0 1 16.5 30v-7.5c0-.141.048-.26.144-.356a.485.485 0 0 1 .356-.144h3.588a.48.48 0 0 1 .312.113c.092.075.15.17.175.287l.125.6h2.3c.142 0 .26.048.356.144a.484.484 0 0 1 .144.356v4c0 .142-.048.26-.144.356A.483.483 0 0 1 23.5 28h-2.587a.48.48 0 0 1-.313-.112.495.495 0 0 1-.175-.288L20.3 27h-2.8v3c0 .142-.048.26-.143.356A.484.484 0 0 1 17 30.5Z"
      />
      <rect
        width={22}
        height={3}
        x={28}
        y={22}
        fill="#F7F8F8"
        opacity={0.9}
        rx={1.5}
      />
      <rect
        width={46}
        height={3}
        x={28}
        y={27}
        fill="#F7F8F8"
        opacity={0.6}
        rx={1.5}
      />
      <rect width={60} height={18} x={14} y={40} fill="#92C9B5" rx={2} />

      <path
        fill="#1F9E80"
        d="M20.5 52.749a.403.403 0 0 1-.297-.12.403.403 0 0 1-.12-.297v-6.25c0-.118.04-.217.12-.297.08-.08.18-.12.297-.12h2.99a.4.4 0 0 1 .26.094.412.412 0 0 1 .146.24l.104.5h1.917c.118 0 .217.04.297.12.08.08.12.178.12.297v3.333c0 .118-.04.217-.12.296a.402.402 0 0 1-.297.12h-2.156a.4.4 0 0 1-.26-.093.412.412 0 0 1-.146-.24l-.105-.5h-2.333v2.5c0 .118-.04.217-.12.297-.08.08-.179.12-.297.12Z"
      />
      <rect
        width={22}
        height={3}
        x={30}
        y={45}
        fill="#F7F8F8"
        opacity={0.9}
        rx={1.5}
      />
      <rect
        width={40}
        height={3}
        x={30}
        y={50}
        fill="#F7F8F8"
        opacity={0.6}
        rx={1.5}
      />
      <defs />
    </svg>
  );
}
